import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  promo: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "promo",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getPromoList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getPromoList.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      promo: payload?.data,
      totalCount: payload?.totalcount,
    }));
    builder.addCase(Act.getPromoList.rejected, (state, action) => ({
      ...state,
      loading: false,
      promo: [],
      totalCount: 0,
    }));

    builder.addCase(Act.updatePromoCode.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.updatePromoCode.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.updatePromoCode.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));

    //add user
    builder.addCase(Act.AddPromo.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(Act.AddPromo.fulfilled, (state, action) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.AddPromo.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
  },
});

export default slice;
